var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center"},[_c('img',{staticClass:"logo",class:{link: _vm.link},style:(_vm.style),attrs:{"src":_vm.asset('logo.png', 'img') + '?1'},on:{"click":_vm.navigate}})])}
var staticRenderFns = []

export { render, staticRenderFns }